module.exports = __webpack_public_path__ + "static/media/FBO9_EDITSINGLELOW.b0b1abaa.mp4";